import type { MembersStats } from '@web/ui/members/hooks';
import { t } from '@web/i18n';
import { AppIcons, type AppIconName, Card } from '@web/ui/core';

interface StatProps {
  label: string;
  icon: AppIconName;
  value: number;
  sub?: string;
}

function Stat({ label, icon, value, sub }: Readonly<StatProps>): React.JSX.Element {
  return (
    <Card>
      <div className="px-4 pt-3.5 pb-3">
        <div className="mb-2 inline-flex items-center gap-1.5 font-mono text-tiny uppercase tracking-eyebrow-loose text-faint-foreground">
          <AppIcons name={icon} size={12} />
          {label}
        </div>
        <div className="flex items-baseline gap-2 font-serif text-3xl font-normal leading-none tracking-tight text-foreground tabular-nums">
          {value}
        </div>
        {sub ? <div className="mt-1.5 text-micro text-muted-foreground">{sub}</div> : null}
      </div>
    </Card>
  );
}

export function StatsRow({ stats }: Readonly<{ stats: MembersStats }>): React.JSX.Element {
  return (
    <div className="mb-6 grid grid-cols-4 gap-2.5">
      <Stat
        label={t('members.stats.total.label')}
        icon="users"
        value={stats.total}
        sub={t('members.stats.total.sub')}
      />
      <Stat label={t('members.stats.newWeek.label')} icon="user-plus" value={stats.newWeek} />
      <Stat
        label={t('members.stats.promoted.label')}
        icon="arrow-up-circle"
        value={stats.promoted}
        sub={t('members.stats.promoted.sub')}
      />
      <Stat
        label={t('members.stats.inactive.label')}
        icon="moon"
        value={stats.inactive}
        sub={t('members.stats.inactive.sub')}
      />
    </div>
  );
}
